import Tool from './Tool';
import { ConnectorEnd } from '../types';
import ConnectorArrowButton from './ConnectorArrowButton';

class ToolConnectorEndArrow extends Tool {
  static toolName = 'Connector end';

  static buttonComponent() {
    return ConnectorArrowButton(ConnectorEnd.CONNECTOR_END);
  }
}

export default ToolConnectorEndArrow;
